import { Component, EventEmitter, Output, Input, forwardRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DxTagBoxComponent } from 'devextreme-angular';

@Component({
    selector: 'app-tag-box',
    templateUrl: './tag-box.component.html',
    styleUrls: ['./tag-box.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TagBoxComponent),
            multi: true
        }
    ],
    standalone: false
})
export class TagBoxComponent implements ControlValueAccessor {
  @ViewChild('tagBox') tagBox: DxTagBoxComponent;
  itemsList: string[];

  _value: string[];
  @Input() get value() {
    return this._value ?? [];
  }
  set value(val) {
    this._value = val;
  }

  @Input() acceptCustomValue: boolean;
  @Input() height: number;

  @Output() valueChange = new EventEmitter<string[]>();

  constructor() { 
    this.itemsList = [];
  }

  onKeyUp(args) {
    if (this.shouldAddNewValue(args.event.key)) {
      this.tryAddNewValue(args);
    }
  }

  shouldAddNewValue(key): boolean {
    return key === ' ' || key === ',' || key === ';';
  }

  onCustomItemCreating(args) {
    const newValue = args.text;
    this.tryAddNewValueToSuggestionsList(newValue);
    args.customItem = newValue;
  }

  onTagBoxTextChange(args) {
    this.tryAddNewValue(args)
  }

  tryAddNewValue(args) {
    const newValue = this.getNewValue();
    if (newValue.length && newValue.trim()) {
      if (!this.tagBox.value || this.tagBox.value.length === 0) {
        this.tagBox.value = [newValue];
      } else {
        this.tagBox.value = [...this.tagBox.value, newValue];
      }

      this.tryAddNewValueToSuggestionsList(newValue);
      args.event.target.value = '';
    }
  }

  tryAddNewValueToSuggestionsList(newValue: string) {
    if(!this.itemsList.some(i=>i===newValue)){
      this.itemsList.unshift(newValue);
    }
  }

  getNewValue(): string {
    const newValue =
      typeof this.tagBox.text === 'string'
        ? this.tagBox.text.endsWith(' ') || this.tagBox.text.endsWith(',') || this.tagBox.text.endsWith(';')
          ? this.tagBox.text.slice(0, -1)
          : this.tagBox.text
        : '';

    return newValue;
  }

  onValueChanged() {
    this.valueChange.emit(this.value);
    this.onTouch(this.value);
    this.onChange(this.value);
  }

  onChange: any = () => { }

  onTouch: any = () => { }

  writeValue(value: any) {
    this.value = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }
}
